import {useState} from 'react';
import {getVenueTracks} from '../../../api';
import ContentModal from '../../organisms/ContentModal';
import clone from 'clone';
import {useReport} from '../../../contexts/ReportContext';
import StatArea, {DefaultStatsLebel} from '../../organisms/StatArea';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import SimpleBar from 'simplebar-react';
import styled from 'styled-components';
import HappyNumberLabel from '../../atoms/HappyNumberLabel';

const ValueStr = styled.div`
  font-size: 50px;
  font-weight: bold;
  line-height: 50px;
  margin-bottom: 27px;
  text-align: center;
`;

export default function VenueReportTracks() {
  const report = useReport();

  const [modalIsOpen, setIsOpen] = useState(false);
  const [itemsData, setItemsData] = useState({
    query: {
      year: 0,
      month: 0,
    },
    items: [],
  });
  const [detailFetched, setDetailFetched] = useState(false);

  function openModal() {
    setIsOpen(true);

    let currentQuery = report.state.fetched_query;
    if (
        itemsData.query.year != currentQuery.year ||
        itemsData.query.month != currentQuery.month
    ) {
      setDetailFetched(false);
      (async () => {
        try {
          let items = await getVenueTracks(
              currentQuery,
          );
          setItemsData({
            query: clone(currentQuery),
            items: items,
          });
          console.log(items);
        } catch (e) {
          console.error(e);
        }
        setDetailFetched(true);
      })();
    }
  }

  function closeModal() {
    setIsOpen(false);
  }

  if (!report.state.data) {
    return (
        <>
          <StatArea
              labelWithInfo={
                <LabelWithInfo
                    text={'Period total\n'}
                    labelclassname={'stats-name-label'}
                >
                  <div></div>
                </LabelWithInfo>
              }
              button={null}
          >
            <ValueStr>
              <HappyNumberLabel text={'0'}/>
            </ValueStr>
            <DefaultStatsLebel text={`tracks`}/>
          </StatArea>
        </>
    );
  }

  let data = report.state.data.tracks;

  let last = (data.previous && data.previous.numerator) || 0;
  let current = (data.current && data.current.numerator) || 0;

  let diff = 0;
  if (last != 0) {
    diff = Math.round((current / last - 1.0) * 100);
  }

  return (
      <>
        <StatArea
            labelWithInfo={
              <LabelWithInfo
                  text={'Period total\n'}
                  labelclassname={'stats-name-label'}
              >
                <div>
                  You can see the total number of tracks issued to the playlists in the selected period. Tap 'See more' to view the top songs.
                </div>
              </LabelWithInfo>
            }

            button={
              <button className="dark-button stats-action" onClick={openModal}>
                <span>See more</span>
              </button>
            }
        >
          <ValueStr>
            <HappyNumberLabel text={current.toLocaleString('en-US')}/>
          </ValueStr>
          <DefaultStatsLebel text={`track${current != 1 ? 's' : ''}`}/>
        </StatArea>

        <ContentModal closeModal={closeModal} isOpen={modalIsOpen} statmodal={1}>
          <div className="fixed-header">
            <h3>Top 10 tracks reported</h3>
            <div className="scroll-header">
              <div className="scroll-header-columns">
                <div className="scroll-header-column">
                  <span>Title / artist</span>
                </div>
                <div className="scroll-header-column last">
                  <div className="dummy-label">
                    {itemsData.items.map((item, i) => {
                      return (
                          <div
                              key={i}
                              style={{
                                top: i * -1,
                              }}
                          >
                            {item.value}
                          </div>
                      );
                    })}
                  </div>
                  <span>Tracks</span>
                </div>
              </div>
            </div>
          </div>
          <SimpleBar forceVisible="y" autoHide={false} className="scroll-area">
            <div
                className={`scroll-content ${
                    !detailFetched || itemsData.items.length
                        ? 'has-items'
                        : 'no-items'
                }`}
            >
              <table className="scroll-table">
                <tbody>
                {itemsData.items.map((item, i) => {
                  let names = [];
                  if (item.track.title) {
                    names.push(item.track.title);
                  }
                  if (item.track.artist) {
                    names.push(item.track.artist);
                  }
                  return (
                      <tr key={i} className="tr">
                        <th>{(i + 1 + '').padStart(2, '0')}</th>
                        <td className="right-border">{names.join(' / ')}</td>
                        <td className="last">{item.value}</td>
                      </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </SimpleBar>
        </ContentModal>
      </>
  );
}
